<template>
  <div class="simexam-wrapper">
    <div class="simexam-score-text" v-if="type === 1">
      <template v-if="[4688].includes(siteConfig.agencyId)">
        您的考试最高分：<span class="simexam-score">{{ simExamMaxScore }}</span>
        分
      </template>
      <template v-else>
        您的考试平均分：
        <span class="simexam-score">{{ simExamAverageScore }}</span> 分
      </template>
    </div>
    <dl class="study-list">
      <dt
        class="clearfix"
        :class="{ active: simExamListVisible }"
        @click="setExamVisible"
      >
        <span class="fl">
          <span class="iconfont icontuoyuanxing"></span>
          <!-- <img src="../../../assets/images/v3/icon-dot.png" /> -->
          {{ typeName }}/{{ simExamList.length }}套
        </span>
        <span class="fr">
          <Icon custom="ich-icon ich-icon-arraw-down" />
        </span>
      </dt>
      <transition name="slide-up">
        <dd v-show="simExamListVisible">
          <div v-for="(item, index) in simExamList" :key="index">
            <span class="icon">
              <img src="../../../assets/images/v3/icon-list.png" />
            </span>
            <span>
              {{ item.examName }}
              <br />
              <span>
                考试次数：
                <span class="text-color">{{ item.simCount }}</span
                >/{{ item.simExamCount > 0 ? item.simExamCount : '不限' }}次
              </span>
              <span>
                最后一次得分：
                <span class="text-color">{{
                  item.lastScore > -1 ? item.lastScore : '教师未评'
                }}</span
                >分
              </span>
              <span>
                <template v-if="item.startTime && item.endTime"
                  >考试开放时间：{{ item.startTime }} 至
                  {{ item.endTime }}</template
                >
                <template v-else>不限时</template>
              </span>
            </span>
            <p class="fr">
              <Button
                v-if="
                  item.simExamCount > 0 && item.simCount >= item.simExamCount
                "
                type="default"
                shape="circle"
                @click="$Message.warning('参与考试次数已满')"
                >开始考试</Button
              >
              <Button
                v-else-if="item.isOpened == 0"
                type="primary"
                shape="circle"
                disabled
                >未 开 放</Button
              >
              <Button
                v-else-if="item.inComPleteSRId == 0 && item.verifyCode"
                type="default"
                shape="circle"
                @click="checkVerifyCode(item)"
                >开始考试</Button
              >
              <Button
                v-else-if="item.inComPleteSRId == 0 && item.authentication == 1"
                type="default"
                shape="circle"
                @click="checkPhoneCode(item)"
                >开始考试</Button
              >
              <Button
                v-else
                type="primary"
                shape="circle"
                @click="gotoExam(item)"
                >开始考试</Button
              >
            </p>
          </div>
        </dd>
      </transition>
    </dl>
    <dl class="study-list">
      <dt
        class="clearfix"
        :class="{ active: simExamHistoryVisible }"
        @click="setHistoryVisible"
      >
        <span class="fl">
          <!-- <img src="../../../assets/images/v3/icon-dot.png" /> -->
          <span class="iconfont icontuoyuanxing"></span>
          考试记录/{{ simExamHistoryList.length }}条
        </span>
        <span class="fr">
          <Icon custom="ich-icon ich-icon-arraw-down" />
        </span>
      </dt>
      <transition name="slide-up">
        <dd v-show="simExamHistoryVisible">
          <div
            v-show="simExamHistoryList.length < 1"
            style="font-size: 18px; color: #666"
          >
            暂无考试记录......
          </div>
          <div v-for="(item, index) in simExamHistoryList" :key="index">
            <span class="icon">
              <img src="../../../assets/images/v3/icon-list.png" />
            </span>
            <span>
              {{ item.srName }}
              <br />
              <template v-if="!item.finish">
                <span>未完成</span>
              </template>
              <template v-else>
                <span v-if="answerTimeHidden">
                  答题时间：
                  <span class="text-color">{{ item.time }}</span
                  >/{{ item.examTime }}分钟
                </span>
                <span v-if="item.isRated">
                  得分：
                  <span class="text-color">{{ item.score }}</span
                  >分
                </span>
                <span v-else> 得分：教师未评分 </span>
              </template>
            </span>
            <p class="fr">
              <Button
                type="primary"
                shape="circle"
                :to="
                  '/course/simexam/' +
                    item.simId +
                    '?umcid=' +
                    umcId +
                    '&srid=' +
                    item.srId
                "
                target="_blank"
                >查看试卷</Button
              >
              <!-- <Button type="primary" :to="{name:'SimExam',params:{id:item.simId},query:{umcid:umcId,srid:item.srId}}" target="_blank">查看试券</Button> -->
            </p>
          </div>
        </dd>
      </transition>
    </dl>

    <!-- 机考验证码弹窗 -->
    <Modal
      v-model="verifyCodeModalVisible"
      :closable="false"
      :mask-closable="false"
    >
      <div class="verify-title">请输入机考验证码，若不了解，请联系招生老师</div>
      <div class="verify-input">
        <span>验证码：</span>
        <Input
          v-model="verifyCode"
          style="width: 200px"
          @on-focus="verifiyTipVisible = false"
        />
      </div>
      <div class="verify-tips">
        <span v-show="verifiyTipVisible">{{ verifyCodeTips }}</span>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="warning" style="width: 100px" @click="submitVerifyCode()"
          >提交</Button
        >
        <Button
          type="default"
          style="width: 100px; margin-left: 2rem"
          @click="verifyCodeModalVisible = false"
          >取消</Button
        >
      </div>
    </Modal>

    <!-- 没有手机号弹窗 -->
    <Modal
      v-model="noPhoneModalVisible"
      title="友情提示"
      :closable="true"
      :mask-closable="false"
      @on-ok="pushBindPhone"
    >
      <div class="phone-no-tips">
        本次考试需要短信验证个人身份，检查到您未绑定手机号
        <br />请前往个人资料绑定手机号
      </div>
    </Modal>

    <!-- 手机验证码弹窗 -->
    <Modal
      v-model="phoneCodeModalVisible"
      title="手机验证"
      :closable="false"
      :mask-closable="false"
    >
      <div class="phone-title">
        本次考试需要短信验证个人身份，短信验证码将发送至{{
          this.loginUser.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }}
      </div>
      <div class="phone-input">
        <span>验证码：</span>
        <Input
          v-model="phoneCode"
          style="width: 130px"
          @on-focus="phoneTipVisible = false"
        />
        <Button style="margin-left: 20px; width: 100px" @click="getPhoneCode">{{
          phoneCodeText
        }}</Button>
      </div>
      <div class="verify-tips">
        <span v-show="phoneTipVisible">{{ phoneCodeTips }}</span>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="warning" style="width: 100px" @click="submitPhoneCode"
          >提交</Button
        >
        <Button
          type="default"
          style="width: 100px; margin-left: 2rem"
          @click="phoneCodeModalVisible = false"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from '../../../utils/mixin';
import { study, account, custom } from '../../../request';
export default {
  name: 'SimExam',
  mixins: [siteMixin],
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      answerTimeHidden: true,
      simExamListVisible: true,
      simExamHistoryVisible: false,
      simExamList: [],
      simExamHistoryList: [],
      simExamAverageScore: 0,
      simExamMaxScore: 0,
      verifyCodeModalVisible: false,
      phoneCodeModalVisible: false,
      noPhoneModalVisible: false,
      verifiyTipVisible: false,
      phoneTipVisible: false,
      verifyCode: '',
      verifyCodeTips: '请填写机考验证码',
      currentVerifyInfo: {},
      phoneCode: '',
      phoneCodeTips: '请填写验证码',
      phoneCodeText: '发送验证码',
      startTime: '',
      endTime: '',
    };
  },
  computed: {
    typeName() {
      let name = this.type && this.type === 1 ? '模拟试卷' : '期末试卷';
      if ([4688].includes(this.siteConfig.agencyId)) {
        name = '试卷';
      }
      return name;
    },
  },
  mounted() {
    this.getExamList();
    this.getExamHistoryList();
    this.handleCustom();
  },
  methods: {
    //定制处理
    handleCustom() {
      //定制化跳转的滚动处理
      //const isCustom = this.$route.query.e;
      const courseId = this.$route.params.cid;
      const srfId = localStorage.getItem('srfId');
      if (srfId) {
        //console.log("srfId", srfId);
        custom.getExamDate(courseId, srfId).then(res => {
          if (res.data) {
            this.startTime = res.data.startTime;
            this.endTime = res.data.endTime;
          }
        });
      }
    },
    getExamList() {
      study.getSimExamList(this.umcId, this.courseId, this.type).then(res => {
        //console.log("sim", res);
        if (res.status === 1) {
          this.simExamList = res.data.SimExamStoreList;
        }
      });
    },
    getExamHistoryList() {
      study.getSimExamHistoryList(this.umcId, this.type).then(res => {
        //console.log("history", res);
        if (res.status === 1) {
          this.simExamHistoryList = res.data.simexamrecordList;
          this.simExamAverageScore = res.data.simexamrecordAVGScore;
          this.simExamMaxScore = res.data.simexamrecordMaxScore;
        }
      });
    },
    gotoExam(item) {
      //机构定制版的判断模考是否在允许的时间段内，依赖startTime和endTime,所有模考都一样
      if (this.startTime && this.endTime) {
        const startTime = new Date(Date.parse(this.startTime));
        const endTime = new Date(Date.parse(this.endTime));
        const nowTime = new Date();
        if (nowTime > endTime || nowTime < startTime) {
          this.$Modal.warning({
            title: '温馨提示',
            content: `请在指定的时间来参加模拟考试<br><br>本课程的模考日期是：<br>${this.startTime}至${this.endTime}`,
          });
          return;
        }
      }
      //正常跳转
      const location = `/course/simexam/${item.simId}?umcid=${this.umcId}`;
      window.open(location, '_blank');
    },
    checkVerifyCode(item) {
      this.currentVerifyInfo = item;
      this.verifyCodeModalVisible = true;
    },
    submitVerifyCode() {
      if (!this.verifyCode) {
        this.verifyCodeTips = '请填写机考验证码';
        this.verifiyTipVisible = true;
        return;
      }
      if (this.verifyCode == this.currentVerifyInfo.verifyCode) {
        this.verifyCodeModalVisible = false;
        if (this.currentVerifyInfo.authentication == 1) {
          this.checkPhoneCode(this.currentVerifyInfo);
        } else {
          let location = this.$router.resolve({
            name: 'SimExam',
            params: { id: this.currentVerifyInfo.simId },
            query: { umcid: this.umcId },
          });
          window.open(location.href, '_blank');
        }
      } else {
        this.verifyCodeTips = '机考验证码填写错误';
        this.verifiyTipVisible = true;
      }
    },
    pushBindPhone() {
      this.$router.push({ name: 'AccountBindPhone' });
    },
    checkPhoneCode(item) {
      this.currentVerifyInfo = item;
      if (this.loginUser.mobile) {
        this.phoneCodeModalVisible = true;
      } else {
        this.noPhoneModalVisible = true;
      }
    },
    submitPhoneCode() {
      if (!this.phoneCode) {
        this.phoneCodeTips = '请填写手机验证码';
        this.phoneTipVisible = true;
        return;
      }
      account
        .checkPhoneCode(this.loginUser.mobile, this.phoneCode)
        .then(res => {
          if (res.status === 1) {
            this.phoneCodeModalVisible = false;
            let location = this.$router.resolve({
              name: 'SimExam',
              params: { id: this.currentVerifyInfo.simId },
              query: { umcid: this.umcId },
            });
            window.open(location.href, '_blank');
          } else {
            this.phoneCodeTips = res.message;
            this.phoneTipVisible = true;
          }
        });
    },
    getPhoneCode() {
      if (!this.isRequest) {
        if (!this.loginUser.mobile) return;
        this.isRequest = true;
        account
          .getPhoneCode(this.loginUser.mobile, this.loginUser.userId)
          .then(result => {
            if (result.status == 1) {
              let second = 60;
              let timer = setInterval(() => {
                second--;
                this.phoneCodeText = `还剩 ${second} 秒`;
                if (second === 0) {
                  this.phoneCodeText = '重新获取';
                  this.isRequest = false;
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$Message.error(result.message);
            }
          });
      }
    },
    setExamVisible() {
      this.simExamListVisible = !this.simExamListVisible;
    },
    setHistoryVisible() {
      this.simExamHistoryVisible = !this.simExamHistoryVisible;
      const hiddenarry = [3328, 4048, 3328];
      this.answerTimeHidden = !hiddenarry.includes(this.siteConfig.agencyId);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/var.less';
@import '../../../assets/css/study.less';
.simexam-wrapper {
  width: 100%;
  padding: 0 10px;
  margin-top: -10px;
  .simexam-score-text {
    font-size: 16px;
    color: #666;
    padding-bottom: 20px;
    .study-list .iconfont {
      color: #3ac2d9 !important;
      font-size: 24px;
    }
  }
  .simexam-score {
    font-size: 40px;
    color: #227efa;
  }
}
.verify-title {
  font-size: 1.6rem;
  padding: 25px 10px 25px 10px;
  text-align: center;
}
.verify-input {
  text-align: center;
}
.verify-tips {
  color: red;
  font-size: 1.4rem;
  height: 20px;
  margin: 10px auto;
  text-align: center;
}
.phone-no-tips {
  font-size: 1.6rem;
  text-align: center;
}
.phone-title {
  text-align: center;
  margin: 20px auto;
}
.phone-input {
  text-align: center;
}
</style>
